import React from "react";
import './FinishedQuizes.scss';
import { renderDonutChart } from "../../../../utils/donutChartFunction";

const FinishedQuizes = (props) => {


       //RENDER TABLE FAVORITES
   const renderFinishedQuizesTable= () => {
    let  data =  props.finishedQuizes;
    //console.log(data);


    return ( 
  /*       <div>
<div className="donut-chart-container">{renderDonutChart()}</div> 
    </div>
      )
    */
    
        data.map(item => {
            console.log(item);
            return(
                <div className="tr-m" key={item.quiz_id}>
                    <div className="text-container">
                        <p className="td-center">{item.quiz_id}</p>
                        <p className="td-center-title">{item.quiz_name}</p>
                    </div>
                    <div className="donut-chart-container">{renderDonutChart(Math.round(item.quiz_resolved))}</div>
                    <div className="td-center">{Math.round(item.quiz_resolved)}%</div>
                </div>
                )
            })
        ) 
            
      
   };

    return (
        <div className="FinishedQuizes">
        <div className="container">
                        <p className="header">Выполненные тесты</p>
                        <div className="table-m">
                           
                            <div className="thead-m">
                                
                                <div className="tr-m">
                                    <p className="th-m">№</p>
                                    <p className="th-m-title">Название</p>
                                 </div>
                                    <p className="th-m">%</p>
                                
                            </div>
                           
                            <div className="tbody-m">
                            {renderFinishedQuizesTable()} 
                            </div>
                        </div>
        </div>
        </div>
    )
}

export default FinishedQuizes;